import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["row"]
    static values = {
        baseName: String,
        minRows: {type: Number, default: 1},
    }

    connect() {
        this.reindex()
        this.updateRemoveButtons()
    }

    add(event) {
        event.preventDefault()

        const last = this.rowTargets[this.rowTargets.length - 1]
        const clone = last.cloneNode(true)

        clone.querySelectorAll("input").forEach((input) => {
            input.value = ""
        })

        this.element.appendChild(clone)
        this.reindex()
        this.updateRemoveButtons()
    }

    remove(event) {
        event.preventDefault()

        if (this.rowTargets.length <= this.minRowsValue) return

        const row = event.target.closest("[data-repeater-target='row']")
        if (!row) return

        row.remove()
        this.reindex()
        this.updateRemoveButtons()
    }

    updateRemoveButtons() {
        const disable = this.rowTargets.length <= this.minRowsValue
        this.element.querySelectorAll("[data-action='repeater#remove']").forEach((btn) => {
            btn.disabled = disable
        })
    }

    reindex() {
        const base = this.baseNameValue
        const safe = base.replace(/[^a-zA-Z0-9_-]/g, "")

        this.rowTargets.forEach((row, index) => {
            row.dataset.rowIndex = index

            const keyInput = row.querySelector("input[name*='[key]']")
            const valueInput = row.querySelector("input[name*='[value]']")

            if (keyInput) {
                keyInput.name = `${base}[${index}][key]`
                keyInput.id = `${safe}_${index}_key`
            }

            if (valueInput) {
                valueInput.name = `${base}[${index}][value]`
                valueInput.id = `${safe}_${index}_value`
            }
            const labels = row.querySelectorAll("label[for]")
            labels.forEach((label) => {
                if (label.getAttribute("for")?.endsWith("_key")) label.setAttribute("for", `${safe}_${index}_key`)
                if (label.getAttribute("for")?.endsWith("_value")) label.setAttribute("for", `${safe}_${index}_value`)
            })
        })
    }
}